module.exports = __webpack_public_path__ + "img/bank-title-th.813df697.png";